import { render } from "./UmwaHeaderDropdownAccnt.vue?vue&type=template&id=e2964bf0"
import script from "./UmwaHeaderDropdownAccnt.vue?vue&type=script&lang=js"
export * from "./UmwaHeaderDropdownAccnt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__